export enum CaRevokeReason {
  UNSPECIFIED = 'UNSPECIFIED',
  KEYCOMPROMISE = 'KEYCOMPROMISE',
  CACOMPROMISE = 'CACOMPROMISE',
  AFFILIATIONCHANGED = 'AFFILIATIONCHANGED',
  SUPERSEDED = 'SUPERSEDED',
  CESSATIONOFOPERATION = 'CESSATIONOFOPERATION',
  CERTIFICATEHOLD = 'CERTIFICATEHOLD',
  REMOVEFROMCRL = 'REMOVEFROMCRL',
  PRIVILEGEWITHDRAWN = 'PRIVILEGEWITHDRAWN',
  AACOMPROMISE = 'AACOMPROMISE',
}
